// PlaceOrderDrawer.jsx
import { useState, useEffect } from 'react';
import {
  Drawer,
  Box,
  IconButton,
  Typography,
  TextField,
  Button,
  Paper,
  Divider,
  CircularProgress,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { pageStyles } from "../../Styles/pageStyles";
import { useTheme } from "@emotion/react";
import { commonServices } from "../../Services/commonServices";
import { apiHandler, currencyFormatter, ErrLoaderOff, delayedNavigate, widthData, LoaderFun, Number2Decimal } from "@shared/Functions/apiHandler";
import FullPageLoader from "@shared/Components/FullPageLoader.jsx";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import MiniLoader from "@shared/Components/miniLoader";
import WalletDesign from "../Cart/walletDesign";


export default function ConfirmOrderDrawer({
  open,
  onClose,
  payload,
  calculatedPrice,
  vendorId,
  setCalculatedPrice,
}) {

  const theme = useTheme();
  const navigate = useNavigate();
  const classes = pageStyles(theme);
  const [promo, setPromo] = useState("");
  const [loader, setLoader] = useState(false);
  const [miniLoader, setMiniLoader] = useState(false);
  const [redeemPoint, setredeemPoint] = useState(false);
  const [promoApplied, setPromoApplied] = useState(false);

  const confirmOrder = async () => {
    let data = {
      "type": 2, // 1 = Cart, 0 = Others
      "deliveryType": 2, // 1 = Delivery Products, 2 = Pick Up Products
      "paymentMethod": "Card",
      "purchaseProducts": payload?.purchaseProducts,
      "addressId": payload?.addressId,
      "vendorId": vendorId,
      redeemPoints: redeemPoint,
      ...(promo && { promoCode: promo }),
    }

    setLoader(true);
    const res = await commonServices.deliveryConfirmOrder(data);
    console.log(res);

    ErrLoaderOff(res, setLoader);
    apiHandler(res);

    if (res?.status === 200) {
      sessionStorage.setItem("orderId", res?.data?.data?.orderId);
      if (calculatedPrice?.finalAmount == 0) {
        setTimeout(() => {
          onClose();
          setLoader(false);
        }, [2000])
        delayedNavigate(navigate, "/main/orderSuccess");
      } else {
        window.location.href = res?.data?.data?.paymentResponse?.authorizationUrl;
      }
    }
  }

  const removePromo = () => {
    setPromo("");
    setPromoApplied(false);
    delete payload["promoCode"];
    getDeliveryCheckout();
  }

  const checkPromo = async () => {
    let data = {
      "promoCode": promo,
      "amount": calculatedPrice?.productsWithTaxesAmount?.summary?.grandTotal,
      "vendorId": vendorId
    }
    const res = await commonServices.checkPromoCode(data);
    apiHandler(res);
    if (res?.status === 200) {
      setPromoApplied(true);
      toast.success(res?.data?.message);
      if (promo) {
        payload["promoCode"] = promo;
      } else {
        delete payload["promoCode"];
      }
      getDeliveryCheckout();
    } else {
      setPromo("");
    }
  };

  const reedemPoints = async () => {
    payload.redeemPoints = !redeemPoint;
    getDeliveryCheckout();
  }

  const getDeliveryCheckout = async () => {
    if (payload && payload?.purchaseProducts?.length > 0) {
      setMiniLoader(true);
      const res = await commonServices.deliveryCheckout(payload);
      apiHandler(res);
      LoaderFun(res, setMiniLoader);
      ErrLoaderOff(res, setMiniLoader);
      if (res?.status === 200) {
        setCalculatedPrice(res?.data?.data);
      }
    }
  }

  const PriceDiv = ({ title, value, deductionStatus }) => {
    return (
      <Box sx={classes.flex_center_btn}>
        <Typography sx={classes.lightTextsmd}>{title}</Typography>
        <Typography
          sx={{ fontSize: theme.palette.textSize.smd }}
          color={deductionStatus ? "green" : theme.palette.text.primary}
        >
          {value}</Typography>
      </Box>)
  }



  useEffect(() => {
    getDeliveryCheckout();
    setPromo('');
    setPromoApplied(false);
  }, [open]);

  return (
    <>
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        slotProps={{
          paper: {
            sx: widthData,
          },
        }}
      >

        {loader && <FullPageLoader />}

        {miniLoader ? <MiniLoader /> :
          <Box sx={{ p: 2, height: "100%", display: "flex", flexDirection: "column" }}>
            <Box sx={classes.flex_c}>
              <IconButton size="small" onClick={onClose}>
                <CloseIcon />
              </IconButton>

              <Typography >
                Confirm Order
              </Typography>
            </Box>

            {/* Promo code */}
            <Paper variant="outlined" sx={classes.paperDiv}>
              <Typography sx={classes.darkTextsmd500}>Promo Code</Typography>
              <Box sx={classes.flex_c}>
                <TextField
                  placeholder="Enter here"
                  value={promo}
                  onChange={(e) => setPromo(e.target.value)}
                  size="small"
                  fullWidth
                  disabled={promoApplied}
                />

                <Button variant="contained" onClick={promoApplied ? removePromo : checkPromo}>
                  {promoApplied ? "Remove" : "Apply"}
                </Button>
              </Box>
              {promoApplied && <Typography sx={classes.promoCode}>Promo Code Applied Successfully</Typography>}
            </Paper>

            <Paper variant="outlined" sx={classes.paperDiv}>
              <Box sx={{ ...classes.flex_center_btn, mb: 1 }}>
                <Typography sx={classes.darkTextsmd500}>Redeem Points</Typography>
                {redeemPoint && <Chip
                  label={redeemPoint ? "Applied" : "Disabled"}
                  color={redeemPoint ? "success" : "error"}
                  size="small"
                  variant="outlined"
                />}
              </Box>

              <PriceDiv title="Available Points" value={calculatedPrice?.loyalityDetails?.loyalityPoints} />

              {calculatedPrice?.loyalityDetails?.loyalityPoints > 0 &&
                <PriceDiv title="Conversion Rate Per Point" value={calculatedPrice?.loyalityDetails?.conversionRate} />}

              {calculatedPrice?.loyalityDetails?.loyalityPoints > 0 &&
                <PriceDiv title="Conversion Amount" value={calculatedPrice?.loyalityDetails?.loyalityPointsAmount} />}


              {calculatedPrice?.loyalityDetails?.loyalityPoints > 0 &&
                <Button
                  variant="contained"
                  onClick={() => { setredeemPoint((prev) => (!prev)); reedemPoints() }}
                  sx={{ mt: 1 }}
                  size="small"
                  fullWidth>
                  {!redeemPoint ? "Apply" : "Cancel"}
                </Button>}
            </Paper>
            
            <WalletDesign Balance={calculatedPrice?.userWallet?.wallet}  />

            <Paper variant="outlined" sx={classes.paperDiv}>
              {calculatedPrice?.productsWithTaxesAmount?.products?.filter(item => item.productType == 1)?.map((item, index) => (
                <>
                  <Typography sx={classes.darkTextsmd500} key={index}> {item.name} </Typography>
                  <PriceDiv title="Quantity" value={Number2Decimal(item.unitsPurchased) + " " + item.measurementName} />
                  <PriceDiv title="Price / Liter" value={currencyFormatter() + Number2Decimal(item.unitPrice)} />
                  <PriceDiv title="Price" value={currencyFormatter() + Number2Decimal(item.purchaseQuantity)} />
                  <Divider sx={{ my: 2 }} />
                </>
              ))}

              {calculatedPrice?.productsWithTaxesAmount?.products?.filter(item => item.productType == 2)?.map((item, index) => (
                <>
                  <Typography sx={classes.darkTextsmd500} key={index}> {item.name} </Typography>
                  <PriceDiv title="Price" value={currencyFormatter() + Number2Decimal(item.unitPrice)} />
                  <Divider sx={{ my: 2 }} />
                </>
              ))}

              <Typography sx={classes.darkTextsmd500}>
                Order Summary
              </Typography>

              <PriceDiv title="Subtotal" value={currencyFormatter() + Number2Decimal(calculatedPrice?.productsWithTaxesAmount?.summary?.subTotal)} />

              <PriceDiv title="Tax" value={currencyFormatter() + Number2Decimal(calculatedPrice?.productsWithTaxesAmount?.summary?.totalTax)} />

              {calculatedPrice?.deliveryPrice > 0 &&
                <PriceDiv title="Delivery Fee" value={currencyFormatter() + Number2Decimal(calculatedPrice?.deliveryPrice)} />}

              {calculatedPrice?.otherTaxAmountDetails?.otherTaxes?.map((data, index) => (
                <PriceDiv key={index} title={data.name} value={currencyFormatter() + Number2Decimal(data.taxAmount)} />
              ))}

              {calculatedPrice?.promoCodeDetails?.amount > 0 &&
                <PriceDiv
                  title="Promo Code Deduction (-)"
                  value={currencyFormatter() + Number2Decimal(calculatedPrice?.promoCodeDetails?.amount)}
                  deductionStatus={true}
                />}

              {calculatedPrice?.loyalityDetails?.usedLoyalityAmount > 0 &&
                <PriceDiv
                  title="Redeem Points Deduction (-)"
                  value={currencyFormatter() + Number2Decimal(calculatedPrice?.loyalityDetails?.usedLoyalityAmount)}
                  deductionStatus={true}
                />}

              {calculatedPrice?.userWallet?.usedWalletAmount > 0 &&
                <PriceDiv
                  title="Wallet Deduction (-)"
                  value={currencyFormatter() + Number2Decimal(calculatedPrice?.userWallet?.usedWalletAmount)}
                  deductionStatus={true}
                />}

              <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1, pt: 1, borderTop: "1px dashed #eee" }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Total</Typography>
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>{currencyFormatter()} {Number2Decimal(calculatedPrice?.finalAmount)}</Typography>
              </Box>
            </Paper>

            {/* Confirm */}
            <Button
              variant="contained"
              onClick={confirmOrder}
              sx={{ my: 2 }}
              disabled={loader}
            >
              {loader ? <CircularProgress size={20} /> : "Confirm Order "}
            </Button>
          </Box>}
      </Drawer>


    </>
  );
}
